module.exports = __webpack_public_path__ + "img/icon-menu-events.8a5760cd.png";